import type { IDropdownProps } from "@similarweb/ui-components";
import {
    CategoryDropdownButton,
    CategoryDropdownItem,
    ConfigDropDown,
    CustomCategoryDropdownItem,
} from "@similarweb/ui-components";

import categoryService from "app/common/services/categoryService";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

export interface ICategoryItem {
    isChild?: boolean;
    text: string;
    id: string;
    isCustomCategory: boolean;
    icon?: string;
    selected?: boolean;
}
export const CategoryItem = (props: ICategoryItem) => {
    const { text, id, isCustomCategory, isChild = false } = props;
    const CategoryItemComponent = isCustomCategory ? CustomCategoryDropdownItem : CategoryDropdownItem;
    return (
        // @ts-expect-error
        <CategoryItemComponent
            key={id}
            {...props}
            isChild={isChild}
        >
            {text}
        </CategoryItemComponent>
    );
};

function defaultSearchFilter(term, item) {
    return item.props.text.toLowerCase().includes(term.toLowerCase());
}

// TODO: Pick from ConfigDropDownProps when available
export interface ICategoryDropdownProps<T = ICategoryItem>
    extends Omit<
        IDropdownProps<T>,
        | "ButtonComponent"
        | "children"
        | "hasSearch"
        | "ItemComponent"
        | "items"
        | "noResultsMessage"
        | "onClick"
        | "searchFilter"
        | "selectedItemId"
        | "shouldScrollToSelected"
    > {
    categories?: Array<T>;
    placeHolder?: T;
    selectedCategoryId?: string;
    categoryButtonComponent?: React.ComponentType;
    categoryItemComponent?: React.ComponentType;
    onSelect: (item: T) => void;
    searchFilter?: (term: string, dropdownItem: T) => boolean;
}

export const CategoryDropdown = ({
    buttonWidth = 196,
    categories = categoryService.getFlattenedCategoriesList(),
    categoryButtonComponent = CategoryDropdownButton,
    categoryItemComponent = CategoryItem,
    dropdownPopupMinScrollHeight = 60,
    dropdownPopupHeight = 180,
    onSelect,
    placeHolder,
    searchFilter = defaultSearchFilter,
    selectedCategoryId = "All",
    ...rest
}: ICategoryDropdownProps) => {
    const t = useTranslation();
    const items = placeHolder ? [placeHolder, ...categories] : categories;

    return (
        <ConfigDropDown
            ButtonComponent={categoryButtonComponent}
            ItemComponent={categoryItemComponent}
            searchFilter={searchFilter}
            selectedItemId={selectedCategoryId}
            onClick={onSelect}
            buttonWidth={buttonWidth}
            dropdownPopupMinScrollHeight={dropdownPopupMinScrollHeight}
            dropdownPopupHeight={dropdownPopupHeight}
            {...rest}
            hasSearch={true}
            items={items}
            noResultsMessage={t("dropdown.no.results")}
            shouldScrollToSelected={true}
        />
    );
};
